import React from "react";
import { Link } from "react-router-dom";

const MakeDifference = () => {
	return (
		<div className='flex flex-col lg:flex-row lg:justify-between items-center py-16 font-sans max-w-[1440px] w-[90%] mx-auto gap-x-10'>
			<h1 className='md:text-[64px]/[76px] text-[38px]/10 tracking-[-1px] font-medium text-[#11112D] mb-4 lg:text-left text-center'>
				Why Get <br />
				Involved?
			</h1>

			<div className='max-w-[768px] mx-auto w-full space-y-8'>
				<ul className='w-full text-left md:text-2xl/[50px] text-[18px]/[38px] text-[#11112d] list-disc pl-5 space-y-4 font-light'>
					<li>
						Be part of a compassionate community making a tangible impact.
					</li>
					<li>Help us advocate for and provide equitable healthcare.</li>
					<li>Join a cause that’s transforming lives every day.</li>
				</ul>

				<div className='flex flex-col sm:flex-row lg:justify-normal justify-center gap-4 text-lg leading-8 text-[#1d1d1d] font-semibold'>
					<Link
						to='/volunteer'
						className='bg-[#22E27F] px-6 py-3 rounded-full sm:w-fit w-w-full text-center'>
						Volunteer Now
					</Link>
					<Link
						to='/donate'
						className='bg-white px-6 py-3 rounded-full border-[#22E27F] border sm:w-fit w-w-full text-center'>
						Donate Now
					</Link>
					<Link
						to='/partner'
						className='bg-white px-6 py-3 rounded-full border-[#22E27F] border sm:w-fit w-w-full text-center'>
						Partner with us
					</Link>
				</div>
			</div>
		</div>
	);
};

export default MakeDifference;
